import { Tooltip, useTooltip } from '../tooltips';
import React, { useState } from 'react';
import { theme } from '../../style';
import { View } from '../common/View';
import { Button } from '../common/Button';
import { DatePicker } from '../select/DateSelect';
import { BudgetTemplateLine } from 'loot-core/src/shared/budget-template';
import { SvgStartingDate } from '../../icons/v2/StartingDate';
import { gray200, gray500 } from '../../style/palette';
import * as d from 'date-fns';
import { useSelector } from 'react-redux';

interface IStartingFromTooltipProps {
  initialValue: string;
  onChange: (date: string) => void;
  onClose: () => void;
}
function StartingFromTooltip({
                               initialValue,
                               onChange,
                               onClose
}: IStartingFromTooltipProps) {
  const firstDayOfWeekIdx = useSelector(state =>
    state.prefs.local?.firstDayOfWeekIdx
      ? state.prefs.local.firstDayOfWeekIdx
      : '0',
  );

  function onSelect(newDate: Date) {
    onChange(d.format(newDate, 'MM/dd/yyyy'));
  }

  return (
    <Tooltip position={'bottom-left'} onClose={onClose}>
      <DatePicker
        firstDayOfWeekIdx={firstDayOfWeekIdx}
        value={initialValue}
        dateFormat={'MM/dd/yyyy'}
        onSelect={onSelect}
      />
    </Tooltip>
  );
}

interface IStartingFromButtonProps {
  budgetLine: Partial<BudgetTemplateLine>;
  onChange: (date: string) => void;
}
export default function StartingFromButton({ budgetLine, onChange }: IStartingFromButtonProps) {
  const [hover, setHover] = useState(false);
  const tooltip = useTooltip();
  const value = budgetLine?.starting_from || null;
  const hasValue = value && value !== '';

  function onChangeInternal(newValue: string) {
    tooltip.close();
    onChange(newValue);
  }

  const [delayHandler, setDelayHandler] = useState(null);

  const handleMouseEnter = () => {
    setDelayHandler(
      setTimeout(() => {
        setHover(true);
      }, 300),
    );
  };

  const handleMouseLeave = () => {
    clearTimeout(delayHandler);
    setHover(false);
  };

  // This account for both the tooltip hover, and editing tooltip
  const tooltipOpen = tooltip.isOpen || (hasValue && hover);

  return (
    <View
      data-adoption-id={'starting-from-btn'}
      style={{ flexShrink: 0 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Button
        type="bare"
        aria-label="Starting from date"
        title={'Starting from date'}
        style={{
          ...(hasValue && { display: 'flex !important' }),
          ...(tooltipOpen && { color: theme.buttonNormalText }),
        }}
        {...tooltip.getOpenEvents()}
      >
        <SvgStartingDate style={{ width: 12, height: 12, fill: hasValue ? gray500 : gray200 }} />
      </Button>
      {tooltipOpen && (
        <StartingFromTooltip
          initialValue={value}
          onChange={onChangeInternal}
          onClose={() => tooltip.close()}
        />
      )}
    </View>
  );
}
